import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'modal-cancel',
    templateUrl: './modal-cancel.component.html',
    styleUrls: ['./modal-cancel.component.scss'],
})
export class ModalCancelComponent {
    recordId: any;
    text: any;

    constructor(
        public dialogRef: MatDialogRef<ModalCancelComponent>,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.text = data.record;
    }

    onNoClick(): void {
        this.dialogRef.close({
            food: 'No',
        });
    }

    cancel(): void {
        this.dialogRef.close({
            food: 'cancel',
        });
    }

    registration(): void {
        this.onNoClick();
        this.router.navigate(['/sign-in']);
    }
}
